import { SUBMIT_EMAIL } from 'state/actions/homeActions';

const initialErrorState = {
  submitEmail: null
};

export default function statusState(state = initialErrorState, action) {
  switch (action.type) {
    case `${SUBMIT_EMAIL}_PENDING`:
    case `${SUBMIT_EMAIL}_FULFILLED`:
      return { ...state, submitEmail: null };
    case `${SUBMIT_EMAIL}_REJECTED`:
      return { ...state, submitEmail: action.payload };
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/reducers/errorReducer.js